export enum GranularityEnum {
  ONE_MINUTE = '1min',
  FIVE_MINUTES = '5min',
  FIFTEEN_MINUTES = '15min',
  THIRTY_MINUTES = '30min',
  ONE_HOUR = 'hour',
  ONE_DAY = 'day',
  ONE_WEEK = 'week',
  ONE_MONTH = 'month',
  ONE_YEAR = 'year',
  MINUTES = 'minutes',
}

export enum GranularityUnitEnum {
  MONTHS = 'MONTHS',
  MINUTES = 'MINUTES',
}
